import { createCustomDomain } from "@redotech/redo-email-domain-rpc/schema/custom-domains/create-custom-domain";
import { deleteCustomDomain } from "@redotech/redo-email-domain-rpc/schema/custom-domains/delete-custom-domain";
import { getCustomDomain } from "@redotech/redo-email-domain-rpc/schema/custom-domains/get-custom-domain";
import { getDefaultSenderAddress } from "@redotech/redo-email-domain-rpc/schema/custom-domains/get-default-sender-address";
import { getEmailDomains } from "@redotech/redo-email-domain-rpc/schema/custom-domains/get-email-domains";
import { getPublicKey } from "@redotech/redo-email-domain-rpc/schema/custom-domains/get-public-key";
import { getReplyToAddress } from "@redotech/redo-email-domain-rpc/schema/custom-domains/get-reply-to-address";
import { getTeamEmailAddresses } from "@redotech/redo-email-domain-rpc/schema/custom-domains/get-team-email-addresses";
import { sendVerificationEmail } from "@redotech/redo-email-domain-rpc/schema/custom-domains/send-verification-email";
import { setCustomDomainMailFromDomain } from "@redotech/redo-email-domain-rpc/schema/custom-domains/set-custom-domain-mail-from-domain";
import { updateCustomDomainEmailSettings } from "@redotech/redo-email-domain-rpc/schema/custom-domains/update-custom-domain-email-settings";
import { verifyMailbox } from "@redotech/redo-email-domain-rpc/schema/custom-domains/verify-mailbox";
import { orderTrackingAnalyticsSchema } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-analytics";
import { createOrderTrackingOrderViewFolder } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/create-order-tracking-order-view-folder";
import { createOrderTrackingViewFolder } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/create-order-tracking-view-folder";
import { deleteOrderTrackingOrderView } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/delete-order-tracking-order-view";
import { deleteOrderTrackingOrderViewFolder } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/delete-order-tracking-order-view-folder";
import { deleteOrderTrackingView } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/delete-order-tracking-view";
import { deleteOrderTrackingViewFolder } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/delete-order-tracking-view-folder";
import { exportOrderTrackingShipments } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/export-order-tracking-shipments";
import { getOrderLookupSettings } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-order-lookup-settings";
import { getOrderTrackingOrderViewsAndFolders } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-order-tracking-order-views-and-folders";
import { getOrderTrackingShipmentDetail } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-order-tracking-shipment-detail";
import { getOrderTrackingShipments } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-order-tracking-shipments";
import { getOrderTrackingViewsAndFolders } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-order-tracking-views-and-folders";
import { getProvidersForTeam } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-providers-for-team";
import { getRecentOrders } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-recent-orders";
import { getTrackingPageGlobalSettings } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-tracking-page-global-settings";
import { getTrackingPageSettings } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/get-tracking-page-settings";
import { saveOrderTrackingOrderViewsAndFolders } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/save-order-tracking-order-views-and-folders";
import { saveOrderTrackingViewsAndFolders } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/save-order-tracking-views-and-folders";
import { updateOrderLookupSettings } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/update-order-lookup-settings";
import { updateOrderTrackingOrderViewFolder } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/update-order-tracking-order-view-folder";
import { updateOrderTrackingShipment } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/update-order-tracking-shipment";
import { updateOrderTrackingViewFolder } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/update-order-tracking-view-folder";
import { updateTrackingPageSettings } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/update-tracking-page-settings";
import { upsertOrderTrackingOrderView } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/upsert-order-tracking-order-view";
import { upsertOrderTrackingView } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/upsert-order-tracking-view";
import { upsertTrackingPageGlobalSettings } from "@redotech/redo-order-tracking-rpc/schema/order-tracking-core/upsert-tracking-page-global-settings";
import { createTrackingPage } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/create-tracking-page";
import { deleteTrackingPage } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/delete-tracking-page";
import { getTrackingPageById } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/get-tracking-page-by-id";
import { getTrackingPageFlowSteps } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/get-tracking-page-flow-steps";
import { getTrackingPages } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/get-tracking-pages";
import { setDefaultTrackingPage } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/set-default-tracking-page";
import { updateTrackingPageById } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/update-tracking-page-by-id";
import { updateTrackingPageFlow } from "@redotech/redo-order-tracking-rpc/schema/tracking-page-flow/update-tracking-page-flow";
import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { createContextLibraryItem } from "./schema/ai-context-library/create-context-library-item";
import { deleteContextLibraryItem } from "./schema/ai-context-library/delete-context-library-item";
import { getContextLibraryItemById } from "./schema/ai-context-library/get-context-library-item-by-id";
import { getContextLibraryItems } from "./schema/ai-context-library/get-context-library-items";
import { getContextLibraryItemsByScenario } from "./schema/ai-context-library/get-context-library-items-by-scenario";
import { updateContextLibraryItem } from "./schema/ai-context-library/update-context-library-item";
import { analyzeSampleCustomers } from "./schema/ai/analyze-customers/analyze-sample-customers";
import {
  getAiAnalyzedFileContent,
  getAiAnalyzedFiles,
} from "./schema/ai/get-ai-analyzed-files";
import { paginateAiAnalyzedFiles } from "./schema/ai/paginate-ai-analyzed-files";
import { sendChatOnboardingMessage } from "./schema/ai/send-chat-onboarding-message";
import { sendContextualOnboardingMessage } from "./schema/ai/send-contextual-onboarding-message";
import { sendMessage } from "./schema/ai/send-message";
import { verifyContextualSetup } from "./schema/ai/verify-contextual-setup";
import { getAttributionSettings } from "./schema/attribution/get-attribution-settings";
import { updateAttributionSettings } from "./schema/attribution/update-attribution-settings";
import { getAudience } from "./schema/audience/get-audience";
import { setCustomerSubscribed } from "./schema/audience/set-customer-subscribed";
import { setCustomerSuppressed } from "./schema/audience/set-customer-suppressed";
import {
  createAutomationOutreachSplit,
  deleteAutomationOutreachSplit,
  getAutomationOutreachSplit,
  getAutomationOutreachSplitMetrics,
  startAutomationOutreachSplit,
  stopAutomationOutreachSplit,
  updateAutomationOutreachSplit,
} from "./schema/automation-outreach-splits";
import { createShopperAgentStrategy } from "./schema/automations/create-shopper-agent-strategy";
import { deleteAutomation } from "./schema/automations/delete-automation";
import { duplicateAutomation } from "./schema/automations/duplicate-automation";
import { duplicateAutomationWithOptions } from "./schema/automations/duplicate-automation-with-options";
import { fixShopperAgentStrategyGuidance } from "./schema/automations/fix-shopper-agent-strategy-guidance";
import { getShopperAgentStrategy } from "./schema/automations/get-shopper-agent-strategy";
import { getTeamAutomations } from "./schema/automations/get-team-automations";
import { revertAutomationToOrigin } from "./schema/automations/revert-automation-to-origin";
import { setAutomationEnabled } from "./schema/automations/set-automation-enabled";
import { updateAutomation } from "./schema/automations/update-automation";
import { updateAutomationSteps } from "./schema/automations/update-automation-steps";
import { updateShopperAgentStrategy } from "./schema/automations/update-shopper-agent-strategy";
import { validateShopperAgentStrategyGuidance } from "./schema/automations/validate-shopper-agent-strategy-guidance";
import { getBackInStockProducts } from "./schema/back-in-stock/get-back-in-stock-products";
import { getBackInStockSubscribers } from "./schema/back-in-stock/get-back-in-stock-subscribers";
import { listBisImports } from "./schema/back-in-stock/list-bis-imports";
import { startBisImport } from "./schema/back-in-stock/start-bis-import";
import { triggerBackInStockNotifications } from "./schema/back-in-stock/trigger-back-in-stock-notifications";
import { getCurrentMarketingEmailInvoice } from "./schema/billing/get-current-marketing-email-invoice";
import { getCurrentMarketingSmsInvoice } from "./schema/billing/get-current-marketing-sms-invoice";
import { getCurrentRecoverInvoice } from "./schema/billing/get-current-recover-invoice";
import { getEstimatedEmailCost } from "./schema/billing/get-estimated-email-cost";
import { getEstimatedSmsCost } from "./schema/billing/get-estimated-sms-cost";
import { getCurrentOrderTrackingInvoice } from "./schema/billing/order-tracking/get-current-order-tracking-invoice";
import { addABTestVariant } from "./schema/campaigns/add-ab-test-variant";
import {
  getCampaignRecipientRevenue,
  getCampaignRecipientsCount,
  paginateCampaignRecipients,
  paginateConvertedCampaignRecipients,
} from "./schema/campaigns/campaign-recipient";
import { cancelCampaign } from "./schema/campaigns/cancel-campaign";
import { checkCampaignSendWarning } from "./schema/campaigns/check-campaign-send-warning";
import { createCampaign } from "./schema/campaigns/create-campaign";
import { deleteCampaign } from "./schema/campaigns/delete-campaign";
import { duplicateCampaign } from "./schema/campaigns/duplicate-campaign";
import { getCampaignById } from "./schema/campaigns/get-campaign-by-id";
import { getCampaignRecipientsByOrderId } from "./schema/campaigns/get-campaign-recipients-by-order-id";
import { getCustomerGroups } from "./schema/campaigns/get-customer-groups";
import { getCustomerGroupsMinimal } from "./schema/campaigns/get-customer-groups-minimal";
import { getTeamCampaigns } from "./schema/campaigns/get-team-campaigns";
import { removeABTestVariant } from "./schema/campaigns/remove-ab-test-variant";
import { updateCampaign } from "./schema/campaigns/update-campaign";
import { activateExistingContextualMerchant } from "./schema/contextual/activate-existing-contextual-merchant";
import { checkContextualCloudflare } from "./schema/contextual/check-contextual-cloudflare";
import { completeContextualOnboarding } from "./schema/contextual/complete-contextual-onboarding";
import { connectGoogleAdsToContextual } from "./schema/contextual/connect-google-ads-to-contextual";
import { connectRedoContextualIntegration } from "./schema/contextual/connect-redo-contextual-integration";
import {
  bulkCreateContextualIntegrations,
  createContextualIntegration,
} from "./schema/contextual/create-contextual-integration";
import {
  bulkDeleteContextualIntegrations,
  deleteContextualIntegration,
} from "./schema/contextual/delete-contextual-integration";
import { getContextualGtmContainer } from "./schema/contextual/get-contextual-gtm-container";
import { getContextualIntegration } from "./schema/contextual/get-contextual-integration";
import { getContextualIntegrations } from "./schema/contextual/get-contextual-integrations";
import { getContextualMetric } from "./schema/contextual/get-contextual-metric";
import { getContextualSetupStatus } from "./schema/contextual/get-contextual-setup-status";
import { getContextualTimeseries } from "./schema/contextual/get-contextual-timeseries";
import { getGoogleAdsContextualStatus } from "./schema/contextual/get-google-ads-contextual-status";
import { listContextualProfiles } from "./schema/contextual/list-contextual-profiles-schema";
import { publishContextualIntegration } from "./schema/contextual/publish-contextual-integration";
import { saveContextualPixelConfig } from "./schema/contextual/save-contextual-pixel-config";
import { setupContextualDomain } from "./schema/contextual/setup-contextual-domain";
import { updateContextualIntegration } from "./schema/contextual/update-contextual-integration";
import { updateContextualIntegrationCredentials } from "./schema/contextual/update-contextual-integration-credentials";
import { getConversationById } from "./schema/conversations/get-conversation-by-id";
import { getCustomerMessageTimeline } from "./schema/conversations/get-customer-message-timeline";
import { getCustomEventNames } from "./schema/custom-events/get-custom-event-names";
import { getCustomEventPropertyKeys } from "./schema/custom-events/get-custom-event-property-keys";
import { createCustomField } from "./schema/customer-custom-fields/create-custom-field";
import { deleteCustomField } from "./schema/customer-custom-fields/delete-custom-field";
import { getCustomFieldOptions } from "./schema/customer-custom-fields/get-custom-field-options";
import { getCustomFields } from "./schema/customer-custom-fields/get-custom-fields";
import { getCustomerPersonas } from "./schema/customers/get-customer-personas";
import { getCustomersCount } from "./schema/customers/get-customers-count";
import { getSegmentsForCustomer } from "./schema/customers/get-segments-for-customer";
import { paginateCustomersWithPersonas } from "./schema/customers/paginate-customers-with-personas";
import { createDiscount } from "./schema/discounts/create-discount";
import { deleteDiscount } from "./schema/discounts/delete-discount";
import {
  getDiscountManagementDetail,
  paginateDiscountManagementDiscounts,
  paginateGeneratedDiscountCodes,
} from "./schema/discounts/discount-management";
import { generatePreviewDiscountCode } from "./schema/discounts/generate-preview-discount-code";
import { getDiscount } from "./schema/discounts/get-discount";
import { getDiscountsByTeam } from "./schema/discounts/get-discounts-by-team";
import { updateDiscount } from "./schema/discounts/update-discount";
import { emailTemplateSchema } from "./schema/email-templates/index";
import { getBooleanFeatureFlag } from "./schema/feature-flags/get-boolean-feature-flag";
import { getStringFeatureFlag } from "./schema/feature-flags/get-string-feature-flag";
import { getUserFeatureFlag } from "./schema/feature-flags/get-user-feature-flag";
import { generateDiscountCode } from "./schema/games/generate-discount-code";
import { getCities } from "./schema/geographic-units/get-cities";
import { getCountries } from "./schema/geographic-units/get-countries";
import { getStates } from "./schema/geographic-units/get-states";
import { getAttribution } from "./schema/get-attribution";
import { getAudienceGrowthAnalytics } from "./schema/get-audience-growth-analytics";
import { getAutomationPerformanceAnalytics } from "./schema/get-automation-performance-analytics";
import { getCampaignPerformanceAnalytics } from "./schema/get-campaign-performance-analytics";
import { getCustomerSuppressionInfo } from "./schema/get-customer-suppression-info";
import { getDailyRevenueMetrics } from "./schema/get-daily-revenue-metrics";
import { getMessagePerformanceMetrics } from "./schema/get-message-performance-metrics";
import { getMonthlyDeliverabilityMetrics } from "./schema/get-monthly-deliverability-metrics";
import { getOutreachAnalytics } from "./schema/get-outreach-analytics";
import { getOutreachUnsubscribes } from "./schema/get-outreach-unsubscribes";
import { getSubscriptionPlans } from "./schema/get-subscription-plans";
import { getSubscriptionProducts } from "./schema/get-subscription-products";
import { getTeamPhoneNumber } from "./schema/get-team-phone-number-schema";
import { cropImage } from "./schema/image/crop-image";
import { editImageWithAi } from "./schema/image/edit-image-with-ai";
import { getOriginalImageUrl } from "./schema/image/get-original-image-url";
import { spellCheckImage } from "./schema/image/spell-check-image";
import { backwardSyncReviews } from "./schema/importers/backward-sync-reviews";
import { createGoogleAdsUserList } from "./schema/integrations/create-google-ads-user-list";
import { createMetaAdsAudience } from "./schema/integrations/create-meta-ads-audience";
import { createTiktokAdsAudience } from "./schema/integrations/create-tiktok-ads-audience";
import { deleteTiktokAdsIntegration } from "./schema/integrations/delete-tiktok-ads-integration";
import { getAttentiveIntegration } from "./schema/integrations/get-attentive-integration";
import { getGoogleAdsCustomers } from "./schema/integrations/get-google-ads-customers";
import { getGoogleAdsIntegration } from "./schema/integrations/get-google-ads-integration";
import { getGoogleAdsOAuthURL } from "./schema/integrations/get-google-ads-oauth-url";
import { getGoogleAdsUserLists } from "./schema/integrations/get-google-ads-user-lists";
import { getGrowaveIntegration } from "./schema/integrations/get-growave-integration";
import { getIntegrationsByTeam } from "./schema/integrations/get-integrations-by-team";
import { getMetaAdsAccounts } from "./schema/integrations/get-meta-ads-accounts";
import { getMetaAdsAudiences } from "./schema/integrations/get-meta-ads-audiences";
import { getMetaAdsIntegration } from "./schema/integrations/get-meta-ads-integration";
import { getMetaAdsOAuthURL } from "./schema/integrations/get-meta-ads-oauth-url";
import { getPostscriptIntegration } from "./schema/integrations/get-postscript-integration";
import { getRechargeIntegration } from "./schema/integrations/get-recharge-integration";
import { getSkioIntegration } from "./schema/integrations/get-skio-integration";
import { getStayAiIntegration } from "./schema/integrations/get-stay-ai-integration";
import { getTiktokAdsAccounts } from "./schema/integrations/get-tiktok-ads-accounts";
import { getTiktokAdsAudiences } from "./schema/integrations/get-tiktok-ads-audiences";
import { getTiktokAdsIntegration } from "./schema/integrations/get-tiktok-ads-integration";
import { getTiktokAdsOAuthURL } from "./schema/integrations/get-tiktok-ads-oauth-url";
import { saveConnectionsToGoogleAds } from "./schema/integrations/save-connections-to-google-ads";
import { saveConnectionsToMetaAds } from "./schema/integrations/save-connections-to-meta-ads";
import { saveConnectionsToTiktokAds } from "./schema/integrations/save-connections-to-tiktok-ads";
import { searchCollections } from "./schema/integrations/search-collections";
import { subscribeToPostscriptWebhook } from "./schema/integrations/subscribe-to-postscript-webhook";
import { unsubscribeFromPostscriptWebhook } from "./schema/integrations/unsubscribe-from-postscript-webhook";
import { updateAttentiveIntegrationPurposes } from "./schema/integrations/update-attentive-integration-purposes";
import { upsertGrowaveIntegration } from "./schema/integrations/upsert-growave-integration";
import { upsertPostscriptIntegration } from "./schema/integrations/upsert-postscript-integration";
import { upsertRechargeIntegration } from "./schema/integrations/upsert-recharge-integration";
import { upsertSkioIntegration } from "./schema/integrations/upsert-skio-integration";
import { upsertStayAiIntegration } from "./schema/integrations/upsert-stay-ai-integration";
import { examplePopulatedLiquidTemplate } from "./schema/liquid/example-populated-liquid-template";
import { createLoyaltyPromotion } from "./schema/loyalty/create-loyalty-promotion";
import { deleteLoyaltyPromotion } from "./schema/loyalty/delete-loyalty-promotion";
import { getLoyaltyConfiguration } from "./schema/loyalty/get-loyalty-configuration";
import { getLoyaltyMembers } from "./schema/loyalty/get-loyalty-members";
import { getLoyaltyMetrics } from "./schema/loyalty/get-loyalty-metrics";
import { getLoyaltyPopupSettings } from "./schema/loyalty/get-loyalty-popup-settings";
import { getLoyaltyPromotions } from "./schema/loyalty/get-loyalty-promotions";
import { getLoyaltyRefundEventForReturn } from "./schema/loyalty/get-loyalty-refund-event-for-return";
import { getLoyaltyPointsEarnedFromOrder } from "./schema/loyalty/get-points-earned-from-order";
import { updateLoyaltyPageSettings } from "./schema/loyalty/update-loyalty-page";
import { updateLoyaltyPopupSettings } from "./schema/loyalty/update-loyalty-popup-settings";
import { updateLoyaltyPromotion } from "./schema/loyalty/update-loyalty-promotion";
import { upsertLoyaltyConfiguration } from "./schema/loyalty/upsert-loyalty-configuration";
import { metaLeadAds } from "./schema/meta-lead-ads/index";
import { connectFalconOfferNetwork } from "./schema/offer-network/connect-falcon-offer-network";
import { connectRoktOfferNetwork } from "./schema/offer-network/connect-rokt-offer-network";
import { connectUptickOfferNetwork } from "./schema/offer-network/connect-uptick-offer-network";
import { createOfferPlacement } from "./schema/offer-network/create-offer-placement";
import { disconnectOfferNetwork } from "./schema/offer-network/disconnect-offer-network";
import { getOfferNetworkIntegrations } from "./schema/offer-network/get-offer-network-integrations";
import { listOfferPlacements } from "./schema/offer-network/list-offer-placements";
import { setOfferNetworkDataSharingConsent } from "./schema/offer-network/set-offer-network-data-sharing-consent";
import { setOrderStatusOfferPlacement } from "./schema/offer-network/set-order-status-offer-placement";
import { setThankYouOfferPlacement } from "./schema/offer-network/set-thank-you-offer-placement";
import { updateFalconSiteSettings } from "./schema/offer-network/update-falcon-site-settings";
import { updateOfferPlacement } from "./schema/offer-network/update-offer-placement";
import { getPersonaAnalytics } from "./schema/personas/get-persona-analytics";
import { createProductFilter } from "./schema/product-filters/create-product-filter";
import { deleteProductFilter } from "./schema/product-filters/delete-product-filter";
import { getCollectionById } from "./schema/product-filters/get-collection-by-id";
import { getProductFilterById } from "./schema/product-filters/get-product-filter-by-id";
import { getProductFiltersByTeam } from "./schema/product-filters/get-product-filters-by-team";
import { updateProductFilter } from "./schema/product-filters/update-product-filter";
import { getProductImages } from "./schema/product-images/get-product-images";
import { getEmailInteractiveProductRecommendations } from "./schema/product-recommendations/get-email-interactive-product-recommendations";
import { getEmailStaticVariantRecommendations } from "./schema/product-recommendations/get-email-static-variant-recommendations";
import { getRecommendedProductsByProvider } from "./schema/product-recommendations/get-recommended-products-by-provider";
import { getTeamProviders } from "./schema/providers/get-team-providers";
import { createRecoverConfig } from "./schema/recover-config/create-recover-config";
import { getRecoverConfigById } from "./schema/recover-config/get-recover-config-by-id";
import { updateRecoverConfig } from "./schema/recover-config/update-recover-config";
import { getMarketingConversationMessages } from "./schema/recover/get-conversation-messages";
import { getExternalSmsMarketingProviderStatus } from "./schema/recover/get-external-sms-marketing-provider-status";
import { getRecoverAggregatedMetrics } from "./schema/recover/get-recover-aggregated-metrics";
import { getRecoverAutomationMetrics } from "./schema/recover/get-recover-automation-metrics";
import { getRecoverConversationLogs } from "./schema/recover/get-recover-conversation-logs";
import { getRecoverDailyMetrics } from "./schema/recover/get-recover-daily-metrics";
import { getRecoverSettings } from "./schema/recover/get-recover-settings";
import { updateRecoverSettings } from "./schema/recover/update-recover-settings";
import { archiveSavedEmailSection } from "./schema/saved-email-sections/archive-saved-email-section";
import { createSavedEmailSection } from "./schema/saved-email-sections/create-saved-email-section";
import { getSavedEmailSectionById } from "./schema/saved-email-sections/get-saved-email-section-by-id";
import { getSavedEmailSections } from "./schema/saved-email-sections/get-saved-email-sections";
import { updateSavedEmailSection } from "./schema/saved-email-sections/update-saved-email-section";
import { createSavedEmailTemplate } from "./schema/saved-templates/create-saved-email-template";
import { deleteSavedEmailTemplate } from "./schema/saved-templates/delete-saved-email-template";
import { getSavedEmailTemplateById } from "./schema/saved-templates/get-saved-email-template-by-id";
import { getSavedEmailTemplates } from "./schema/saved-templates/get-saved-email-templates";
import { getUpdatedSavedEmailTemplates } from "./schema/saved-templates/get-updated-saved-email-templates";
import { paginateSavedEmailTemplates } from "./schema/saved-templates/paginate-saved-email-templates";
import { updateSavedEmailTemplate } from "./schema/saved-templates/update-saved-email-template";
import { createDynamicSegment } from "./schema/segments/create-dynamic-segment";
import { createSampledSegment } from "./schema/segments/create-sampled-segment";
import { createStaticSegment } from "./schema/segments/create-static-segment";
import { deleteSegment } from "./schema/segments/delete-segment";
import { deleteSegments } from "./schema/segments/delete-segments";
import { duplicateSegmentWithOptions } from "./schema/segments/duplicate-segment-with-options";
import { fetchSegmentById } from "./schema/segments/fetch-segment-by-id";
import { fetchTeamSegments } from "./schema/segments/fetch-team-segments";
import { getEstimatedCampaignRecipientCount } from "./schema/segments/get-estimated-campaign-recipient-count";
import { getOrCreateTexasSegmentForTeam } from "./schema/segments/get-or-create-texas-segment-for-team";
import { getSegmentCollections } from "./schema/segments/get-segment-collections";
import { getSegmentConditionCatalog } from "./schema/segments/get-segment-condition-catalog";
import { getSegmentCount } from "./schema/segments/get-segment-count";
import { getSegmentMembers } from "./schema/segments/get-segment-members";
import { getSegmentProductVendors } from "./schema/segments/get-segment-product-vendors";
import { getSegmentProducts } from "./schema/segments/get-segment-products";
import { getShopifySegments } from "./schema/segments/get-shopify-segments";
import { getTokenFieldOptions } from "./schema/segments/get-token-field-options";
import { refreshSegmentCount } from "./schema/segments/refresh-segment-count";
import { updateDynamicSegment } from "./schema/segments/update-dynamic-segment";
import { updateStaticSegment } from "./schema/segments/update-static-segment";
import { generateSandboxReply } from "./schema/shopper-agent/generate-sandbox-reply";
import { generateSandboxTrigger } from "./schema/shopper-agent/generate-sandbox-trigger";
import { getCommerceAgentCapabilities } from "./schema/shopper-agent/get-commerce-agent-capabilities";
import { getDraftShopperAgentSettings } from "./schema/shopper-agent/get-draft-shopper-agent-settings";
import { getPublishedShopperAgentSettings } from "./schema/shopper-agent/get-published-shopper-agent-settings";
import { getRecoverSmsSenderReady } from "./schema/shopper-agent/get-recover-sms-sender-ready";
import { getShopperAgentConfigState } from "./schema/shopper-agent/get-shopper-agent-config-state";
import { getShopperAgentConfigVersions } from "./schema/shopper-agent/get-shopper-agent-config-versions";
import { getShopperAgentEscalationSettings } from "./schema/shopper-agent/get-shopper-agent-escalation-settings";
import { publishShopperAgentConfig } from "./schema/shopper-agent/publish-shopper-agent-config";
import { revertShopperAgentConfig } from "./schema/shopper-agent/revert-shopper-agent-config";
import { selectSandboxCustomer } from "./schema/shopper-agent/select-sandbox-customer";
import { updateBaseShopperAgentSettings } from "./schema/shopper-agent/update-base-shopper-agent-settings";
import { updateShopperAgentCooldown } from "./schema/shopper-agent/update-shopper-agent-cooldown";
import { updateShopperAgentDiscount } from "./schema/shopper-agent/update-shopper-agent-discount";
import { updateShopperAgentSkill } from "./schema/shopper-agent/update-shopper-agent-skill";
import { createSignupForm } from "./schema/signup-form/create-signup-form";
import { createSignupFormSplit } from "./schema/signup-form/create-signup-form-split";
import { deleteSignupForm } from "./schema/signup-form/delete-signup-form";
import { duplicateSignupForm } from "./schema/signup-form/duplicate-signup-form";
import { getMarketingSubscriberCounts } from "./schema/signup-form/get-marketing-subscriber-counts";
import { getSignupFormById } from "./schema/signup-form/get-signup-form-by-id";
import { getSignupFormDisclosureSupportEmail } from "./schema/signup-form/get-signup-form-disclosure-support-email";
import { getSignupFormOptionsMinimal } from "./schema/signup-form/get-signup-form-options-minimal";
import { getSignupFormSplits } from "./schema/signup-form/get-signup-form-splits";
import { getSignupFormsByTeamId } from "./schema/signup-form/get-signup-forms-by-team-id";
import { unpublishSignupForm } from "./schema/signup-form/unpublish-signup-form";
import { updatePublishedAt } from "./schema/signup-form/update-published-at";
import { updateSignupForm } from "./schema/signup-form/update-signup-form";
import { updateSignupFormSplitStatus } from "./schema/signup-form/update-signup-form-split-status";
import { createSmsSignupTemplates } from "./schema/sms-template/create-sms-signup-template";
import { createSmsTemplate } from "./schema/sms-template/create-sms-template";
import { deleteSmsTemplate } from "./schema/sms-template/delete-sms-template";
import { createContentGeneratorConfig } from "./schema/sms-templates/create-content-generator-config";
import { createScenario } from "./schema/sms-templates/create-scenario";
import { deleteScenario } from "./schema/sms-templates/delete-scenario";
import { generateSmsAiContentPreview } from "./schema/sms-templates/generate-sms-ai-content-preview";
import { getContentGeneratorConfigPopulated } from "./schema/sms-templates/get-content-generator-config-populated";
import { getSmsTemplateAiOptions } from "./schema/sms-templates/get-sms-template-ai-options";
import { getSmsTemplateById } from "./schema/sms-templates/get-sms-template-by-id";
import { getSmsTemplateByIdPopulated } from "./schema/sms-templates/get-sms-template-by-id-populated";
import { paginateSmsTemplates } from "./schema/sms-templates/paginate-sms-templates";
import { publishContentGeneratorConfig } from "./schema/sms-templates/publish-content-generator-config";
import { sendTestSMSById } from "./schema/sms-templates/send-test-sms-by-id";
import { updateScenario } from "./schema/sms-templates/update-scenario";
import { updateSmsTemplate } from "./schema/sms-templates/update-sms-template";
import { speechToText } from "./schema/speech-to-text/speech-to-text";
import { createSubscribeKeyword } from "./schema/subscribe-keywords/create-subscribe-keyword";
import { deleteSubscribeKeyword } from "./schema/subscribe-keywords/delete-subscribe-keyword";
import { getSubscribeKeywords } from "./schema/subscribe-keywords/get-subscribe-keywords";
import { updateSubscribeKeyword } from "./schema/subscribe-keywords/update-subscribe-keyword";
import { setPreferredSupportEmail } from "./schema/support-connection/set-preferred-support-email";

// -----------------------------------------------------------------------------
// RPC Definition Groups
// Splitting into smaller groups improves TypeScript declaration emit performance.
// When InferRpcDefinition processes 250+ endpoints at once, TypeScript must
// compute and serialize massive intersection types. By pre-computing smaller
// group types and combining them, we reduce emit time significantly.
// See: https://github.com/microsoft/TypeScript/wiki/Performance#preferring-interfaces-over-intersections
// -----------------------------------------------------------------------------

const aiSchema = {
  getAiAnalyzedFileContent,
  getAiAnalyzedFiles,
  paginateAiAnalyzedFiles,
  generateSmsAiContentPreview,
  sendChatOnboardingMessage,
  verifyContextualSetup,
  sendContextualOnboardingMessage,
  sendMessage,
  analyzeSampleCustomers,
};
type AiRpc = InferRpcDefinition<typeof aiSchema>;

const imageSchema = {
  cropImage,
  editImageWithAi,
  getOriginalImageUrl,
  spellCheckImage,
};
type ImageRpc = InferRpcDefinition<typeof imageSchema>;

const aiContextLibrarySchema = {
  getContextLibraryItems,
  getContextLibraryItemsByScenario,
  createContextLibraryItem,
  getContextLibraryItemById,
  updateContextLibraryItem,
  deleteContextLibraryItem,
};
type AiContextLibraryRpc = InferRpcDefinition<typeof aiContextLibrarySchema>;

const audienceSchema = {
  getAudience,
  setCustomerSubscribed,
  setCustomerSuppressed,
};
type AudienceRpc = InferRpcDefinition<typeof audienceSchema>;

const automationsSchema = {
  createShopperAgentStrategy,
  getShopperAgentStrategy,
  getTeamAutomations,
  setAutomationEnabled,
  updateAutomation,
  updateAutomationSteps,
  updateShopperAgentStrategy,
  validateShopperAgentStrategyGuidance,
  fixShopperAgentStrategyGuidance,
  deleteAutomation,
  duplicateAutomation,
  duplicateAutomationWithOptions,
  revertAutomationToOrigin,
  examplePopulatedLiquidTemplate,
  getCustomEventNames,
  getCustomEventPropertyKeys,
};
type AutomationsRpc = InferRpcDefinition<typeof automationsSchema>;

const automationOutreachSplitSchema = {
  createAutomationOutreachSplit,
  getAutomationOutreachSplit,
  getAutomationOutreachSplitMetrics,
  updateAutomationOutreachSplit,
  startAutomationOutreachSplit,
  stopAutomationOutreachSplit,
  deleteAutomationOutreachSplit,
};
type AutomationOutreachSplitRpc = InferRpcDefinition<
  typeof automationOutreachSplitSchema
>;

const customersSchema = {
  paginateCustomersWithPersonas,
  getCustomersCount,
  getCustomerPersonas,
  getSegmentsForCustomer,
};
type CustomersRpc = InferRpcDefinition<typeof customersSchema>;

const billingSchema = {
  getCurrentMarketingEmailInvoice,
  getCurrentMarketingSmsInvoice,
  getCurrentRecoverInvoice,
  getEstimatedEmailCost,
  getEstimatedSmsCost,
  getCurrentOrderTrackingInvoice,
};
type BillingRpc = InferRpcDefinition<typeof billingSchema>;

const campaignSchema = {
  cancelCampaign,
  createCampaign,
  deleteCampaign,
  duplicateCampaign,
  getCampaignById,
  getCampaignRecipientsCount,
  getCampaignRecipientsByOrderId,
  getTeamCampaigns,
  paginateCampaignRecipients,
  paginateConvertedCampaignRecipients,
  getCampaignRecipientRevenue,
  updateCampaign,
  addABTestVariant,
  removeABTestVariant,
  checkCampaignSendWarning,
};
type CampaignRpc = InferRpcDefinition<typeof campaignSchema>;

const customFieldsSchema = {
  createCustomField,
  deleteCustomField,
  getCustomFields,
  getCustomFieldOptions,
};
type CustomFieldsRpc = InferRpcDefinition<typeof customFieldsSchema>;

const discountSchema = {
  createDiscount,
  deleteDiscount,
  generatePreviewDiscountCode,
  getDiscount,
  getDiscountManagementDetail,
  getDiscountsByTeam,
  paginateDiscountManagementDiscounts,
  paginateGeneratedDiscountCodes,
  updateDiscount,
};
type DiscountRpc = InferRpcDefinition<typeof discountSchema>;

const geographicSchema = { getCities, getCountries, getStates };
type GeographicRpc = InferRpcDefinition<typeof geographicSchema>;

const integrationSchema = {
  createGoogleAdsUserList,
  createMetaAdsAudience,
  getAttentiveIntegration,
  updateAttentiveIntegrationPurposes,
  getGoogleAdsCustomers,
  getGoogleAdsIntegration,
  getGoogleAdsOAuthURL,
  getGoogleAdsUserLists,
  getGrowaveIntegration,
  upsertGrowaveIntegration,
  getMetaAdsAccounts,
  getMetaAdsAudiences,
  getMetaAdsIntegration,
  getMetaAdsOAuthURL,
  getTiktokAdsOAuthURL,
  getTiktokAdsIntegration,
  deleteTiktokAdsIntegration,
  getTiktokAdsAccounts,
  getTiktokAdsAudiences,
  createTiktokAdsAudience,
  saveConnectionsToTiktokAds,
  getPostscriptIntegration,
  subscribeToPostscriptWebhook,
  unsubscribeFromPostscriptWebhook,
  upsertPostscriptIntegration,
  getRechargeIntegration,
  upsertRechargeIntegration,
  getSkioIntegration,
  upsertSkioIntegration,
  getStayAiIntegration,
  upsertStayAiIntegration,
  saveConnectionsToGoogleAds,
  saveConnectionsToMetaAds,
  searchCollections,
  getIntegrationsByTeam,
  getOfferNetworkIntegrations,
  connectRoktOfferNetwork,
  connectFalconOfferNetwork,
  connectUptickOfferNetwork,
  disconnectOfferNetwork,
  listOfferPlacements,
  createOfferPlacement,
  updateOfferPlacement,
  updateFalconSiteSettings,
  setThankYouOfferPlacement,
  setOrderStatusOfferPlacement,
  setOfferNetworkDataSharingConsent,
  ...metaLeadAds,
};
type IntegrationRpc = InferRpcDefinition<typeof integrationSchema>;

const orderTrackingSchema = {
  getOrderTrackingShipments,
  getOrderTrackingShipmentDetail,
  updateOrderTrackingShipment,
  exportOrderTrackingShipments,
  getOrderTrackingViewsAndFolders,
  upsertOrderTrackingView,
  deleteOrderTrackingView,
  saveOrderTrackingViewsAndFolders,
  createOrderTrackingViewFolder,
  updateOrderTrackingViewFolder,
  deleteOrderTrackingViewFolder,
  getOrderTrackingOrderViewsAndFolders,
  upsertOrderTrackingOrderView,
  deleteOrderTrackingOrderView,
  saveOrderTrackingOrderViewsAndFolders,
  createOrderTrackingOrderViewFolder,
  updateOrderTrackingOrderViewFolder,
  deleteOrderTrackingOrderViewFolder,
  getProvidersForTeam,
  getRecentOrders,
  getTrackingPageSettings,
  updateTrackingPageSettings,
  getTrackingPageGlobalSettings,
  upsertTrackingPageGlobalSettings,
  getOrderLookupSettings,
  updateOrderLookupSettings,
};
type OrderTrackingRpc = InferRpcDefinition<typeof orderTrackingSchema>;

const trackingPageFlowSchema = {
  createTrackingPage,
  deleteTrackingPage,
  getTrackingPageById,
  getTrackingPageFlowSteps,
  getTrackingPages,
  setDefaultTrackingPage,
  updateTrackingPageById,
  updateTrackingPageFlow,
};
type TrackingPageFlowRpc = InferRpcDefinition<typeof trackingPageFlowSchema>;

const productFilterSchema = {
  createProductFilter,
  deleteProductFilter,
  getCollectionById,
  getProductFilterById,
  getProductFiltersByTeam,
  updateProductFilter,
};
type ProductFilterRpc = InferRpcDefinition<typeof productFilterSchema>;

const savedEmailTemplateSchema = {
  createSavedEmailTemplate,
  getSavedEmailTemplateById,
  getSavedEmailTemplates,
  getUpdatedSavedEmailTemplates,
  paginateSavedEmailTemplates,
  updateSavedEmailTemplate,
  deleteSavedEmailTemplate,
};
type SavedEmailTemplateRpc = InferRpcDefinition<
  typeof savedEmailTemplateSchema
>;

const segmentSchema = {
  createDynamicSegment,
  createStaticSegment,
  deleteSegment,
  deleteSegments,
  duplicateSegmentWithOptions,
  fetchSegmentById,
  getSegmentConditionCatalog,
  fetchTeamSegments,
  getEstimatedCampaignRecipientCount,
  getOrCreateTexasSegmentForTeam,
  getSegmentCollections,
  getSegmentCount,
  getSegmentMembers,
  getSegmentProducts,
  getSegmentProductVendors,
  getShopifySegments,
  getTokenFieldOptions,
  refreshSegmentCount,
  updateDynamicSegment,
  updateStaticSegment,
  createSampledSegment,
};
type SegmentRpc = InferRpcDefinition<typeof segmentSchema>;

const signupFormSchema = {
  createSignupForm,
  createSignupFormSplit,
  deleteSignupForm,
  getMarketingSubscriberCounts,
  getSignupFormById,
  getSignupFormDisclosureSupportEmail,
  getSignupFormOptionsMinimal,
  getSignupFormsByTeamId,
  getSignupFormSplits,
  unpublishSignupForm,
  updatePublishedAt,
  updateSignupForm,
  updateSignupFormSplitStatus,
  duplicateSignupForm,
};
type SignupFormRpc = InferRpcDefinition<typeof signupFormSchema>;

const customDomainSchema = {
  getCustomDomain,
  createCustomDomain,
  verifyMailbox,
  sendVerificationEmail,
  setCustomDomainMailFromDomain,
  updateCustomDomainEmailSettings,
  deleteCustomDomain,
  getPublicKey,
  getReplyToAddress,
  getDefaultSenderAddress,
  getTeamEmailAddresses,
  getEmailDomains,
};
type CustomDomainRpc = InferRpcDefinition<typeof customDomainSchema>;

const loyaltySchema = {
  getLoyaltyConfiguration,
  getLoyaltyMembers,
  getLoyaltyMetrics,
  getLoyaltyPopupSettings,
  upsertLoyaltyConfiguration,
  getLoyaltyPromotions,
  createLoyaltyPromotion,
  updateLoyaltyPromotion,
  deleteLoyaltyPromotion,
  getLoyaltyRefundEventForReturn,
  getLoyaltyPointsEarnedFromOrder,
  updateLoyaltyPageSettings,
  updateLoyaltyPopupSettings,
};
type LoyaltyRpc = InferRpcDefinition<typeof loyaltySchema>;

const analyticsSchema = {
  getAttribution,
  getAudienceGrowthAnalytics,
  getAutomationPerformanceAnalytics,
  getCampaignPerformanceAnalytics,
  getDailyRevenueMetrics,
  getCustomerSuppressionInfo,
  getMessagePerformanceMetrics,
  getMonthlyDeliverabilityMetrics,
  getOutreachAnalytics,
  getOutreachUnsubscribes,
};
type AnalyticsRpc = InferRpcDefinition<typeof analyticsSchema>;

const marketingAgentSchema = {
  generateSandboxReply,
  generateSandboxTrigger,
  selectSandboxCustomer,
  updateBaseShopperAgentSettings,
  updateShopperAgentCooldown,
  updateShopperAgentDiscount,
  updateShopperAgentSkill,
  getCommerceAgentCapabilities,
  getDraftShopperAgentSettings,
  getPublishedShopperAgentSettings,
  getRecoverSmsSenderReady,
  getShopperAgentConfigState,
  getShopperAgentConfigVersions,
  getShopperAgentEscalationSettings,
  publishShopperAgentConfig,
  revertShopperAgentConfig,
};
type MarketingAgentRpc = InferRpcDefinition<typeof marketingAgentSchema>;

const smsSchema = {
  deleteSmsTemplate,
  createSmsTemplate,
  createContentGeneratorConfig,
  getContentGeneratorConfigPopulated,
  getSmsTemplateById,
  getSmsTemplateByIdPopulated,
  getSmsTemplateAiOptions,
  paginateSmsTemplates,
  publishContentGeneratorConfig,
  sendTestSMSById,
  updateSmsTemplate,
  createSmsSignupTemplates,
  getTeamPhoneNumber,
  createScenario,
  updateScenario,
  deleteScenario,
};
type SmsRpc = InferRpcDefinition<typeof smsSchema>;

const recommendationSchema = {
  getEmailStaticVariantRecommendations,
  getEmailInteractiveProductRecommendations,
  getRecommendedProductsByProvider,
};
type RecommendationRpc = InferRpcDefinition<typeof recommendationSchema>;

const providersSchema = { getTeamProviders };
type ProvidersRpc = InferRpcDefinition<typeof providersSchema>;

const savedEmailSectionsSchema = {
  getSavedEmailSections,
  getSavedEmailSectionById,
  createSavedEmailSection,
  updateSavedEmailSection,
  archiveSavedEmailSection,
};
type SavedEmailSectionsRpc = InferRpcDefinition<
  typeof savedEmailSectionsSchema
>;

const importersSchema = { backwardSyncReviews };
type ImportersRpc = InferRpcDefinition<typeof importersSchema>;

const conversationsSchema = { getConversationById, getCustomerMessageTimeline };
type ConversationsRpc = InferRpcDefinition<typeof conversationsSchema>;

const recoverSchema = {
  createRecoverConfig,
  getRecoverConversationLogs,
  getMarketingConversationMessages,
  getRecoverAggregatedMetrics,
  getRecoverAutomationMetrics,
  getRecoverDailyMetrics,
  getExternalSmsMarketingProviderStatus,
  getRecoverSettings,
  updateRecoverSettings,
  getRecoverConfigById,
  updateRecoverConfig,
};
type RecoverRpc = InferRpcDefinition<typeof recoverSchema>;

const attributionSchema = { getAttributionSettings, updateAttributionSettings };
type AttributionRpc = InferRpcDefinition<typeof attributionSchema>;

const subscribeKeywordsSchema = {
  getSubscribeKeywords,
  createSubscribeKeyword,
  updateSubscribeKeyword,
  deleteSubscribeKeyword,
};
type SubscribeKeywordsRpc = InferRpcDefinition<typeof subscribeKeywordsSchema>;

const personaSchema = { getPersonaAnalytics };
type PersonaRpc = InferRpcDefinition<typeof personaSchema>;

const featureFlagsSchema = {
  getBooleanFeatureFlag,
  getStringFeatureFlag,
  getUserFeatureFlag,
};
type FeatureFlagsRpc = InferRpcDefinition<typeof featureFlagsSchema>;

const productImagesSchema = { getProductImages };
type ProductImagesRpc = InferRpcDefinition<typeof productImagesSchema>;

const subscriptionProductsSchema = {
  getSubscriptionPlans,
  getSubscriptionProducts,
};
type SubscriptionProductsRpc = InferRpcDefinition<
  typeof subscriptionProductsSchema
>;

const supportSchema = { setPreferredSupportEmail };
type SupportRpc = InferRpcDefinition<typeof supportSchema>;

const customerGroupsSchema = { getCustomerGroups, getCustomerGroupsMinimal };
type CustomerGroupsRpc = InferRpcDefinition<typeof customerGroupsSchema>;

const trackingPageSchema = { generateDiscountCode };
type TrackingPageRpc = InferRpcDefinition<typeof trackingPageSchema>;

const backInStockSchema = {
  getBackInStockProducts,
  getBackInStockSubscribers,
  startBisImport,
  listBisImports,
  triggerBackInStockNotifications,
};
type BackInStockRpc = InferRpcDefinition<typeof backInStockSchema>;

const contextualSchema = {
  listContextualProfiles,
  setupContextualDomain,
  checkContextualCloudflare,
  activateExistingContextualMerchant,
  getContextualSetupStatus,
  completeContextualOnboarding,
  connectGoogleAdsToContextual,
  getContextualIntegration,
  getGoogleAdsContextualStatus,
  getContextualIntegrations,
  getContextualGtmContainer,
  getContextualMetric,
  getContextualTimeseries,
  connectRedoContextualIntegration,
  createContextualIntegration,
  bulkCreateContextualIntegrations,
  deleteContextualIntegration,
  bulkDeleteContextualIntegrations,
  updateContextualIntegrationCredentials,
  publishContextualIntegration,
  updateContextualIntegration,
  saveContextualPixelConfig,
};
type ContextualRpc = InferRpcDefinition<typeof contextualSchema>;

const speechToTextSchema = { speechToText };
type SpeechToTextRpc = InferRpcDefinition<typeof speechToTextSchema>;

export const rpcDefinition: typeof aiSchema &
  typeof imageSchema &
  typeof aiContextLibrarySchema &
  typeof audienceSchema &
  typeof customersSchema &
  typeof personaSchema &
  typeof automationsSchema &
  typeof automationOutreachSplitSchema &
  typeof billingSchema &
  typeof campaignSchema &
  typeof customFieldsSchema &
  typeof discountSchema &
  typeof emailTemplateSchema &
  typeof featureFlagsSchema &
  typeof geographicSchema &
  typeof integrationSchema &
  typeof importersSchema &
  typeof orderTrackingSchema &
  typeof trackingPageFlowSchema &
  typeof orderTrackingAnalyticsSchema &
  typeof productFilterSchema &
  typeof productImagesSchema &
  typeof subscriptionProductsSchema &
  typeof savedEmailTemplateSchema &
  typeof segmentSchema &
  typeof signupFormSchema &
  typeof supportSchema &
  typeof customDomainSchema &
  typeof analyticsSchema &
  typeof smsSchema &
  typeof recommendationSchema &
  typeof providersSchema &
  typeof customerGroupsSchema &
  typeof loyaltySchema &
  typeof trackingPageSchema &
  typeof backInStockSchema &
  typeof speechToTextSchema &
  typeof savedEmailSectionsSchema &
  typeof conversationsSchema &
  typeof recoverSchema &
  typeof attributionSchema &
  typeof marketingAgentSchema &
  typeof contextualSchema &
  typeof subscribeKeywordsSchema = {
  ...aiSchema,
  ...imageSchema,
  ...aiContextLibrarySchema,
  ...audienceSchema,
  ...customersSchema,
  ...personaSchema,
  ...automationsSchema,
  ...automationOutreachSplitSchema,
  ...billingSchema,
  ...campaignSchema,
  ...customFieldsSchema,
  ...discountSchema,
  ...emailTemplateSchema,
  ...featureFlagsSchema,
  ...geographicSchema,
  ...integrationSchema,
  ...importersSchema,
  ...orderTrackingSchema,
  ...trackingPageFlowSchema,
  ...orderTrackingAnalyticsSchema,
  ...productFilterSchema,
  ...productImagesSchema,
  ...subscriptionProductsSchema,
  ...savedEmailTemplateSchema,
  ...segmentSchema,
  ...signupFormSchema,
  ...supportSchema,
  ...customDomainSchema,
  ...analyticsSchema,
  ...smsSchema,
  ...recommendationSchema,
  ...providersSchema,
  ...customerGroupsSchema,
  ...loyaltySchema,
  ...trackingPageSchema,
  ...backInStockSchema,
  ...speechToTextSchema,
  ...savedEmailSectionsSchema,
  ...conversationsSchema,
  ...recoverSchema,
  ...attributionSchema,
  ...marketingAgentSchema,
  ...contextualSchema,
  ...subscribeKeywordsSchema,
};

export type RedoMarketingRpcDefinition = AiRpc &
  ImageRpc &
  AiContextLibraryRpc &
  AudienceRpc &
  CustomersRpc &
  PersonaRpc &
  AutomationsRpc &
  AutomationOutreachSplitRpc &
  BillingRpc &
  CampaignRpc &
  CustomFieldsRpc &
  DiscountRpc &
  InferRpcDefinition<typeof emailTemplateSchema> &
  FeatureFlagsRpc &
  GeographicRpc &
  IntegrationRpc &
  ImportersRpc &
  OrderTrackingRpc &
  TrackingPageFlowRpc &
  InferRpcDefinition<typeof orderTrackingAnalyticsSchema> &
  ProductFilterRpc &
  ProductImagesRpc &
  SubscriptionProductsRpc &
  SavedEmailTemplateRpc &
  SegmentRpc &
  SignupFormRpc &
  SupportRpc &
  CustomDomainRpc &
  AnalyticsRpc &
  SmsRpc &
  RecommendationRpc &
  ProvidersRpc &
  CustomerGroupsRpc &
  LoyaltyRpc &
  TrackingPageRpc &
  BackInStockRpc &
  SpeechToTextRpc &
  SavedEmailSectionsRpc &
  ConversationsRpc &
  RecoverRpc &
  AttributionRpc &
  MarketingAgentRpc &
  ContextualRpc &
  SubscribeKeywordsRpc;
